// Import necessary components and libraries
import {
  ChartCard,
  ChartNoDataFound,
  ChartsTooltip,
  formatNumberToK,
  handelWeekDaysToArrayOfObjects,
  useEffect,
  useState,
} from "@";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  useBankOrdersQuery,
  useCardOrdersQuery,
  useOrdersAmountQuery,
} from "../utils/queries.js";

const Chart = ({
  title,
  queryType = "cardOrders",
  prefix = "عدد الطلبات ",
}) => {
  const [data, setData] = useState([]);
  const [searchDuration, setSearchDuration] = useState(3);

  // Select the appropriate query hook based on queryType
  const queries = {
    cardOrders: useCardOrdersQuery,
    bankOrders: useBankOrdersQuery,
    ordersAmount: useOrdersAmountQuery,
  };

  const useQueryHook = queries[queryType] || useCardOrdersQuery;
  const { data: queryData } = useQueryHook(searchDuration);

  // Update the chart data and colors based on the fetched results
  const updateChartData = (res) => {
    if (!res) {
      setData([]);
      return;
    }
    const updatedData = handelWeekDaysToArrayOfObjects(res);
    setData(updatedData);
  };

  // Fetch data based on the duration
  const fetchData = (value) => {
    setSearchDuration(value);
  };

  const renderBarLabel =
    (dataKey) =>
    ({ x, y, width, index }) =>
      data[index][dataKey] >= 0 && (
        <text
          className="fill-purple-900 dark:fill-purple-700"
          fontSize={12}
          fontWeight={700}
          x={x + width / 2}
          y={y - 10}
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {formatNumberToK(data[index][dataKey])}
        </text>
      );

  useEffect(() => {
    if (queryData) {
      updateChartData(queryData);
    }
  }, [queryData]);

  return (
    <ChartCard searchDurationUpdated={fetchData} title={title}>
      <div className="h-80">
        {data?.length > 0 ? (
          <ResponsiveContainer
            style={{ direction: "ltr" }}
            width="100%"
            height="100%"
          >
            <BarChart margin={{ top: 30, left: -20 }} barSize={23} data={data}>
              <CartesianGrid
                className="stroke-gray-100 dark:stroke-gray-700"
                strokeDasharray="0 0"
              />
              <Tooltip content={<ChartsTooltip prefix={prefix} />} />
              <YAxis
                tickFormatter={formatNumberToK}
                fontSize={12}
                strokeWidth={0}
              />

              <XAxis
                padding={{ left: 15 }}
                fontSize={12}
                dataKey="key"
                strokeWidth={0}
              />

              <Bar
                label={renderBarLabel("value")}
                radius={[5, 5, 0, 0]}
                className="fill-purple-900 dark:fill-purple-700"
                dataKey="value"
              />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <ChartNoDataFound />
        )}
      </div>
    </ChartCard>
  );
};

export default Chart;
